import * as angular from 'angular';

import { LocationInformationFormComponent } from './LocationInformationFormComponent';

var locationInformationModule = angular.module('app.areas.common.locationInformation', []);

locationInformationModule
    .component(LocationInformationFormComponent.$name, new LocationInformationFormComponent());

export default locationInformationModule.name;
